module.exports = __webpack_public_path__ + "static/media/aster_all.35dcf7de.png";